// extracted by mini-css-extract-plugin
export var clickableWrapper = "_2c-2";
export var placeholderIcon = "_2c-3";
export var thumbnailCanvas = "_2c-1";
export var thumbnailWrapper = "_2c-0";